import { render, staticRenderFns } from "./DropdownMessageTemplate.vue?vue&type=template&id=40d47069&"
import script from "./DropdownMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./DropdownMessageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports